import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { BlockContainer } from "../../BaseComponents/Wrappers/BlockContainer/BlockContainer";
import { H2 } from "../../BaseComponents/Text";
import { InnerBlockContainer } from "../../BaseComponents/Wrappers/InnerBlockContainer/InnerBlockContainer";
import { mapScript } from "./ScriptBlock.utils";

export const ScriptBlock = ({ Heading, ScriptType }) => {
	const scriptRef = useRef();

	useEffect(() => {
		if (scriptRef != undefined) {
			mapScript(ScriptType, scriptRef.current);
		}
	}, []);

	return (
		<BlockContainer>
			<InnerBlockContainer>
				{!!Heading && (
					<H2 textAlign="center" margin="0 0 1rem 0">
						{Heading}
					</H2>
				)}
				<div ref={scriptRef}></div>
			</InnerBlockContainer>
		</BlockContainer>
	);
};

ScriptBlock.propTypes = {
	Heading: PropTypes.string,
	ScriptType: PropTypes.string,
};
